import { Stack, styled, Typography, type Theme } from '@mui/material';

import { formatNumberByThousands } from '@/shared/helpers/format.helpers';

import { AnimatedNumbers } from '../AnimatedNumbers';

const StyledRoot = styled(Stack)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1.5),
})) as typeof Stack;

type TextVariant = keyof Theme['palette']['text'];

export type SummaryEntryProps = {
  name: string;
  value: React.ReactNode;
  textVariant?: TextVariant;
  nameTextVariant?: TextVariant;
  valueTextVariant?: TextVariant;
};

export const SummaryEntry = (props: SummaryEntryProps) => {
  const { name, value, textVariant = 'primary', nameTextVariant, valueTextVariant, ...restOfProps } = props;

  return (
    <StyledRoot direction="row" spacing={0.5} {...restOfProps}>
      <Typography component="div" variant="Body/Bold/medium" color={`text.${nameTextVariant ?? textVariant}`}>
        {name}:
      </Typography>
      <Typography component="div" variant="Body/Bold/medium" color={`text.${valueTextVariant ?? textVariant}`}>
        {value}
      </Typography>
    </StyledRoot>
  );
};

export type AnimatedSummaryEntryProps = Omit<SummaryEntryProps, 'value'> & {
  name: string;
  value: number;
  textVariant?: TextVariant;
  nameTextVariant?: TextVariant;
  valueTextVariant?: TextVariant;
};

export const AnimatedSummaryEntry = (props: AnimatedSummaryEntryProps) => {
  const { value, ...restProps } = props;

  return <SummaryEntry value={<AnimatedNumbers value={value} format={formatNumberByThousands} />} {...restProps} />;
};
